module.exports = __webpack_public_path__ + "static/img/generalSDKBgEng.0b51092.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/generalSDKBgEng.png
// module id = g3ve
// module chunks = 1